import { createFeatureSelector, createSelector } from '@ngrx/store';

import { TailBitingModuleState } from '../../model/tail-biting.model';

export const getTailBitingModuleState =
  createFeatureSelector<TailBitingModuleState>('tailBitingModule');

export const getTailBitings = createSelector(
  getTailBitingModuleState,
  (state) => state.tailBitings,
);

export const getSelectedLocations = createSelector(
  getTailBitingModuleState,
  (state) => state.locations,
);

export const getSelectedTailBiting = createSelector(
  getTailBitingModuleState,
  (state) => state.selectedTailBiting,
);
